<template>
  <v-container>
    <Title title="Unit Details"></Title>
    <h2 class="py-5" style="display: inline-block">Unit Details</h2>
    <BulkUploader :type="'unit'" style="float: right" />
    <v-stepper v-model="e6" vertical>
      <v-stepper-step color="#6490f1" :complete="e6 > 1" step="1" editable
        >Unit Info</v-stepper-step
      >
      <v-stepper-content step="1">
        <v-form ref="detailsForm">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                ref="firstInput"
                v-model="unitName"
                label="Unit Name *"
                class="my-3"
                :rules="emptyRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="unitCode"
                label="Unit Code *"
                class="my-3"
                :rules="emptyRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="uan"
                label="UAN"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="selectedUnitType"
                :items="modifiedUnitTypes"
                label="Unit Type *"
                :rules="emptyRule"
                class="my-3"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="selectedUnitLevel"
                :items="unitLevels"
                label="Unit Level"
                class="my-3"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="selectedUnitStatus"
                :items="unitStatus"
                label="Unit Status"
                class="my-3"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="unitCredits"
                type="number"
                label="Unit Credits"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="unitNumber"
                label="Unit Number"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="unitNote"
                label="Unit Note"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                ref="startMenu"
                v-model="startMenu"
                :close-on-content-click="false"
                :return-value.sync="startDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startDate"
                    label="Unit Start Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="my-3"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  no-title
                  scrollable
                  @input="$refs.startMenu.save(startDate)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                ref="reviewMenu"
                v-model="reviewMenu"
                :close-on-content-click="false"
                :return-value.sync="reviewDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="reviewDate"
                    label="Unit Review Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="my-3"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="reviewDate"
                  no-title
                  scrollable
                  @input="$refs.reviewMenu.save(reviewDate)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="tqt"
                type="number"
                label="Total Qualification Time *"
                :rules="emptyRule"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="selectedCriterion"
                :items="gradingCriterions"
                :rules="emptyRule"
                label="Grading Criterion *"
                class="my-3"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="selectedLanguage"
                :items="gradingLanguages"
                label="Grading Language"
                class="my-3"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="minLearningHours"
                type="number"
                label="Minimum Guided Learning Hours  *"
                :rules="emptyRule"
                class="my-3"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="selectedNoOfResits"
                :items="noOfResits"
                label="Number of Resits"
                class="my-3"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-combobox
                v-model="selectedDeliveryMode"
                :items="deliveryModes"
                clearable
                label="Delivery Mode *"
                multiple
                class="my-3"
              ></v-combobox>
            </v-col>
          </v-row>
        </v-form>
        <v-btn tile dark class="primary-color" @click="onSubmitDetails()"
          >Continue</v-btn
        >
        <div class="mb-5"></div>
      </v-stepper-content>

      <v-stepper-step color="#6490f1" :complete="e6 > 2" step="2" editable
        >Unit Descriptions</v-stepper-step
      >
      <v-stepper-content step="2">
        <v-row class="mb-10">
          <v-col cols="12">
            <template v-if="isDescriptionLoaded">
              <Editor
                :description="unitDescription"
                @updateContent="updateContent"
              />
            </template>
          </v-col>
        </v-row>
        <div class="my-12"></div>
        <v-btn tile dark @click="e6 = 3" class="mt-6 primary-color"
          >Continue</v-btn
        >
        <v-btn tile text @click="e6 = 1" class="mt-6">Previous</v-btn>
        <div class="mb-5"></div>
      </v-stepper-content>

      <v-stepper-step color="#6490f1" :complete="e6 > 3" step="3" editable
        >Unit Materials</v-stepper-step
      >
      <v-stepper-content step="3">
        <v-form class="mt-2">
          <v-row>
            <v-col cols="12" md="12">
              <p>
                Unit Image (File Format: JPEG, PNG)
                <input
                  type="file"
                  accept=".jpg, .jpeg, .png"
                  @change="onAddFile($event, 0)"
                />
              </p>
              <div class="preview mb-12">
                <embed v-if="imageUrl" :src="imageUrl" />
              </div>
            </v-col>
            <v-col cols="12" md="12">
              <p>
                Unit Video (File Format: MP4)
                <input
                  type="file"
                  accept=".mp4"
                  @change="onAddFile($event, 1)"
                />
              </p>
              <div class="preview mb-12">
                <embed v-if="videoUrl" :src="videoUrl" />
              </div>
            </v-col>
            <v-col cols="12" md="12">
              <p>
                Unit Brochure (File Format: JPEG, PDF)
                <input
                  type="file"
                  accept=".jpg, .jpeg, .png, .pdf"
                  @change="onAddFile($event, 2)"
                />
              </p>
              <div class="preview mb-12">
                <embed v-if="brochureUrl" :src="brochureUrl" />
              </div>
            </v-col>
            <v-col cols="12" md="12">
              <p>
                Unit Guide (File Format: PDF)
                <input
                  type="file"
                  accept=".pdf"
                  @change="onAddFile($event, 3)"
                />
              </p>
              <div class="preview mb-12">
                <embed v-if="guideUrl" :src="guideUrl" />
              </div>
            </v-col>
          </v-row>
        </v-form>
        <v-btn tile dark @click="e6 = 4" class="primary-color">Continue</v-btn>
        <v-btn tile text @click="e6 = 2">Previous</v-btn>
        <div class="mb-5"></div>
      </v-stepper-content>

      <v-stepper-step color="#6490f1" :complete="e6 > 4" step="4" editable
        >Learning Outcomes</v-stepper-step
      >
      <v-stepper-content step="4">
        <v-row>
          <v-list-item
            two-line
            v-for="(outcome, index) in learningOutcomes"
            :key="index"
          >
            <v-list-item-content>
              <v-list-item-title
                >{{ index + 1 }}. {{ outcome.description }}
                <!-- <a
                  class="pl-5"
                  style="text-decoration: underline"
                  @click="onRemoveLearningOutcome(outcome._id, index)"
                  >Remove</a
                > -->
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ outcome.assessment }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-row>
        <v-form>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="loDescription"
                name="input-7-1"
                label="Description"
                class="my-3"
                rows="3"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="loAssessment"
                name="input-7-1"
                label="How will it be assessed?"
                class="mt-3"
                rows="3"
              ></v-textarea>
            </v-col>
            <v-btn
              text
              color="primary"
              class="mb-5"
              @click="onAddLearningOutcome()"
              >Add learning outcome</v-btn
            >
          </v-row>
        </v-form>
        <v-btn tile dark class="primary-color" @click="e6 = 5">Continue</v-btn>
        <v-btn tile text @click="e6 = 3">Previous</v-btn>
        <div class="mb-5"></div>
      </v-stepper-content>

      <v-stepper-step color="#6490f1" :complete="e6 > 5" step="5" editable
        >Courses Associated</v-stepper-step
      >
      <v-stepper-content step="5">
        <v-form>
          <v-row>
            <v-col cols="12" md="12">
              <v-combobox
                v-model="selectedCoursesAssociated"
                :items="courses"
                chips
                clearable
                label="Courses"
                :rules="comboboxRule"
                hide-selected
                multiple
                class="my-3"
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    small
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="removeCourseAssociated(item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
        </v-form>
        <v-btn
          tile
          dark
          class="primary-color"
          @click="onReviewSummary()"
          :editable="isEditable"
          >Review Summary</v-btn
        >
        <v-btn tile text @click="e6 = 4">Previous</v-btn>
        <div class="mb-5"></div>
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import Editor from "../components/Editor";
import BulkUploader from "../components/BulkUploader";
import Title from "../components/Title";

export default {
  mounted: async function () {
    await this.getQualifications();
    this.getUnitTypes();
    this.getUnitLevels();
    this.getUnitStatuses();
    this.getGradingCriterions();
    this.getLanguages();
    this.getUnit();

    this.$refs.firstInput.focus();

    if (this.$route.query.id) {
      this.isDescriptionLoaded = false;
      this.isEditable = true;
    }
  },
  components: {
    Editor,
    BulkUploader,
    Title,
  },
  data() {
    return {
      e6: 1,
      startMenu: false,
      reviewMenu: false,
      deliveryModes: ["Online", "Blended", "Face to Face"],
      noOfResits: [0, 1, 2, 3],
      unitTypes: [],
      unitLevels: [],
      unitStatus: [],
      gradingCriterions: [],
      gradingLanguages: [],
      courses: [],
      unitName: null,
      unitCode: null,
      uan: null,
      unitDescription: null,
      selectedUnitType: null,
      selectedUnitLevel: null,
      unitCredits: null,
      selectedUnitStatus: null,
      unitNumber: null,
      unitNote: null,
      startDate: null,
      reviewDate: null,
      tqt: null,
      selectedCriterion: null,
      selectedLanguage: null,
      minLearningHours: null,
      selectedNoOfResits: 1,
      selectedDeliveryMode: null,
      unitImage: null,
      unitVideo: null,
      unitBrochure: null,
      unitGuide: null,
      emptyRule: [(v) => !!v || "This field is required"],
      isEditable: false,
      isDescriptionLoaded: true,
      imageUrl: null,
      videoUrl: null,
      brochureUrl: null,
      guideUrl: null,
      qualifications: [],
      learningOutcomes: [],
      loDescription: null,
      loAssessment: null,
      selectedCoursesAssociated: [],
    };
  },
  computed: {
    modifiedUnitTypes: function () {
      const role = this.$store.state.role;

      if (role == "centre") {
        return this.unitTypes.filter((type) => {
          return type.toLowerCase() != "accredited";
        });
      }

      return this.unitTypes;
    },
  },
  methods: {
    // onRemoveLearningOutcome: function (id, index) {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const unitId = urlParams.get("id");

    //   fetch(
    //     `${process.env.VUE_APP_ROOT_API}/units/${unitId}/learningOutcomes/${id}`,
    //     {
    //       method: "DELETE",
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${this.$store.state.jwt}`,
    //       },
    //     }
    //   )
    //     .then((response) => response.json())
    //     .then(() => {
    //       this.learningOutcomes.splice(index, 1);
    //     })
    //     .catch((error) => {
    //       console.error(error);
    //     });
    // },
    unitItem: function () {
      const coursesAssociatedWith = [];

      for (let i = 0; i < this.selectedCoursesAssociated.length; i++) {
        for (let j = 0; j < this.qualifications.length; j++) {
          if (
            this.selectedCoursesAssociated[i] == this.qualifications[j].code
          ) {
            coursesAssociatedWith.push(this.qualifications[j]._id);
          }
        }
      }

      return {
        name: this.unitName,
        code: this.unitCode,
        uan: this.uan,
        description: this.unitDescription,
        type: this.selectedUnitType,
        level: this.selectedUnitLevel,
        credits: this.unitCredits,
        status: this.selectedUnitStatus,
        number: this.unitNumber,
        note: this.unitNote,
        startDate: this.startDate,
        reviewDate: this.reviewDate,
        tqt: this.tqt,
        gradingCriterion: this.selectedCriterion,
        gradingLanguage: this.selectedLanguage,
        minimumHour: this.minLearningHours,
        noOfResits: this.selectedNoOfResits,
        deliveryMode: this.selectedDeliveryMode,
        image: this.unitImage,
        video: this.unitVideo,
        brochure: this.unitBrochure,
        guide: this.unitGuide,
        learningOutcomes: this.learningOutcomes,
        coursesAssociatedWith,
      };
    },
    writeToForm: function (item) {
      const selectedCoursesAssociated = [];

      for (let i = 0; i < item.coursesAssociatedWith.length; i++) {
        for (let j = 0; j < this.qualifications.length; j++) {
          if (item.coursesAssociatedWith[i] == this.qualifications[j]._id) {
            selectedCoursesAssociated.push(this.qualifications[j].code);
          }
        }
      }

      this.unitName = item.name;
      this.unitCode = item.code;
      this.uan = item.uan;
      this.unitDescription = item.description;
      this.selectedUnitType =
        item.type.charAt(0).toUpperCase() + item.type.slice(1);
      this.selectedUnitLevel = item.level;
      this.unitCredits = item.credits;
      this.selectedUnitStatus = item.status;
      this.unitNumber = item.number;
      this.unitNote = item.note;
      this.startDate = item.startDate;
      this.reviewDate = item.reviewDate;
      this.tqt = item.tqt;
      this.selectedCriterion =
        item.gradingCriterion.charAt(0).toUpperCase() +
        item.gradingCriterion.slice(1);
      this.selectedLanguage = item.gradingLanguage;
      this.minLearningHours = item.minimumHour;
      this.selectedNoOfResits = item.noOfResits;
      this.selectedDeliveryMode = item.deliveryMode;
      this.unitImage = item.image;
      this.unitVideo = item.video;
      this.unitBrochure = item.brochure;
      this.unitGuide = item.guide;
      this.isDescriptionLoaded = true;
      this.selectedCoursesAssociated = selectedCoursesAssociated;
      this.learningOutcomes = item.learningOutcomes;
    },
    getQualifications: function () {
      const promise = fetch(`${process.env.VUE_APP_ROOT_API}/qualifications`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.qualifications = data.qualifications;
          this.courses = data.qualifications.map(
            (qualification) => qualification.code
          );
        })
        .catch((error) => {
          console.error(error);
        });

      return promise;
    },
    removeCourseAssociated(item) {
      this.selectedCoursesAssociated.splice(
        this.selectedCoursesAssociated.indexOf(item),
        1
      );
      this.selectedCoursesAssociated = [...this.selectedCoursesAssociated];
    },
    getUnit: function () {
      if (this.$route.params.item) {
        // editing new unit
        this.writeToForm(this.$route.params.item);
      } else if (this.$route.query.id) {
        // edit exisiting unit
        fetch(`${process.env.VUE_APP_ROOT_API}/units/${this.$route.query.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            this.writeToForm(data.unit);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    getUnitTypes: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/unitTypes`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.unitTypes = data.unitTypes.map((type) => type.name);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getUnitLevels: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/unitLevels`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.unitLevels = data.unitLevels.map((level) => level.name);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getUnitStatuses: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/unitStatuses`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.unitStatus = data.unitStatuses.map((status) => status.name);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getGradingCriterions: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/gradingCriterions`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.gradingCriterions = data.gradingCriterions.map(
            (criterion) => criterion.name
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getLanguages: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/languages`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.gradingLanguages = data.languages.map(
            (language) => language.name
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onReviewSummary() {
      if (this.$route.query.id) {
        this.$router.push({
          name: "Summary",
          params: { section: "units", item: this.unitItem() },
          query: { id: this.$route.query.id },
        });
      } else {
        this.$router.push({
          name: "Summary",
          params: { section: "units", item: this.unitItem() },
        });
      }
    },
    onSubmitDetails: function () {
      const validate = this.$refs.detailsForm.validate();

      if (validate) {
        this.isEditable = true;
        this.e6 = 2;
      }
    },
    updateContent: function (content) {
      this.unitDescription = content;
    },
    onAddFile: function (e, index) {
      const file = e.target.files[0];

      if (index == 0) {
        this.imageUrl = URL.createObjectURL(file);
        this.unitImage = file;
      } else if (index == 1) {
        this.videoUrl = URL.createObjectURL(file);
        this.unitVideo = file;
      } else if (index == 2) {
        this.brochureUrl = URL.createObjectURL(file);
        this.unitBrochure = file;
      } else if (index == 3) {
        this.guideUrl = URL.createObjectURL(file);
        this.unitGuide = file;
      }
    },
    onAddLearningOutcome: function () {
      this.learningOutcomes.push({
        description: this.loDescription,
        assessment: this.loAssessment,
      });

      this.loDescription = null;
      this.loAssessment = null;
    },
  },
};
</script>

<style scoped>
* {
  padding-top: 0;
  padding-bottom: 0;
}

.form-title {
  display: inline-block;
}

#continue-btn {
  float: right;
}

#preview-container {
  height: 500px;
  overflow-y: scroll;
}

.preview {
  display: flex;
}

.preview embed {
  width: 70%;
  height: 400px;
}

/* md size */
@media (min-width: 960px) {
}

/* sm size */
@media (min-width: 600px) and (max-width: 960px) {
}

/* xs size */
@media only screen and (max-width: 600px) {
}
</style>